// extracted by mini-css-extract-plugin
export default {"itemBody":"passage_itemBody__4D2nL","dropdown":"passage_dropdown__BGxL8"};